import React from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { STATUS_TABS } from './helpers'

const StatusTabs = ({ activeTab, counts = {}, onChange }) => {
  return (
    <Tabs
      value={activeTab}
      onChange={(e, value) => onChange(value)}
      variant="scrollable"
      scrollButtons="auto"
      className="border-b border-divider"
      data-testid="status-tabs"
    >
      {STATUS_TABS.map(({ key, label }) => (
        <Tab
          key={key}
          value={key}
          label={`${label} (${counts[key] ?? 0})`}
          data-testid={`status-tab-${key}`}
        />
      ))}
    </Tabs>
  )
}

export default StatusTabs
